import React from "react";
import { dispDateHour, getDomain } from "../helpers";

class AdminItemCtct extends React.Component {
    render() {
        return <div className={`admintchat__mess admintchat__mess--${this.props.data.sender} ${this.props.data.isRead == false && "admintchat__mess--notread"}`}>
            <span className="admintchat__hour">{dispDateHour(this.props.data.date.date)}</span>
            <p className="admintchat__text">{this.props.data.message}</p>
            {
                this.props.data.file != null &&
                <img src={`${getDomain()}image/tchat/${this.props.data.file}`} alt="Illustration du message" className="admintchat__img" />
            }
        </div>
    }
}

export default AdminItemCtct;